<template>
  <ion-page>
    <ion-content>
      <ion-grid>
        <ion-row>
          <ion-col size="12">
            <ion-label>ご登録済みのメールアドレスの変更が可能です。</ion-label>
          </ion-col>
          <ion-col size="12">
            <ion-label>変更するメールアドレスを入力し、「送信」ボタンを押してください。</ion-label>
          </ion-col>
          <ion-col size="12">
            <br/>
            <ion-label style="display: flex; align-items: center; font-size: 18px" color="danger">
              <ion-icon :icon="warning" style="font-size: 22px"></ion-icon>ご注意ください
            </ion-label>
            <ion-label color="danger" class="ion-margin-top">
              認証コード通知メールの送信元が変わりました。<br/>
              「info.kutsu.com」と「chiyodagrp.co.jp」からのメールが受信できるよう、受信設定してください。
            </ion-label>
            <br/>
            <br/>
          </ion-col>
        </ion-row>
        <RequiredInput label="新しいメールアドレス"/>
        <ion-row>
          <ion-col size="12">
            <ion-input class="required-input" v-model="email" helper-text="例）yamada@example.co.jp ※半角英字で入力"></ion-input>
            <ion-text color="danger" v-if="errors && errors.email">{{ errors.email }}</ion-text>
          </ion-col>
        </ion-row>
        <ion-button class="ion-margin-top primary-button" expand="block" @click="submitForm">メールを送信する ></ion-button>
        <ion-button class="ion-margin-top secondary-button" expand="block" fill="outline" @click="goBackToMembershipCard">会員証に戻る ></ion-button>
      </ion-grid>
    </ion-content>

    <ion-loading trigger="open-loading" :duration="3000" message="  処理中..."></ion-loading>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonPage,
  IonLoading,
  loadingController,
  LoadingOptions, IonLabel, IonRow, IonInput, IonGrid, IonCol, IonButton, IonContent, IonText, IonIcon,
} from "@ionic/vue";

import request from '@/utils/Request'
import { useRouter } from 'vue-router'
import StorageService from '@/utils/StorageService'
import { Device } from '@capacitor/device';
import {useField, useForm, useFormErrors} from "vee-validate";
import RequiredInput from "@/components/RequiredInput.vue";
import {goBackToMembershipCard} from "@/helpers/platform";
import {warning} from "ionicons/icons";

const router = useRouter()
const form = useForm()
const errors = useFormErrors() as any;

const { value: email } = useField<number>('email');

async function submitForm() {
  const deviceInfo = await Device.getInfo()

  const loading = await createLoading('送信処理中...')
  await loading.present()
  await request.post('/register', {
    email: email.value,
    app_id: import.meta.env.VITE_APP_ID,
    device_uuid: await StorageService.get('deviceUuid'),
    osVersion: deviceInfo.osVersion,
    os: deviceInfo.operatingSystem,
    mode: 'mail_change'
  }).then(async (res) => {
    if (res.status) {
      router.push({name: 'CodeVerifyPageOfMailChange', query: {email: email.value}})
      const loading = await createLoading('メールを送信しました', 2000,null)
      loading.present()
    }
  }).catch((err) => {
    if (err.response?.status == 422) {
      form.setErrors(err.response.data.errors);
      return;
    }
    form.setErrors({email: ['エラーが発生しました']})
  }).finally(() => {
    loading.dismiss()
  })
}

async function createLoading(msg: string, duration?: number, spinner: LoadingOptions["spinner"] = "crescent") {
  return await loadingController.create({
      message: msg,
      duration: duration,
      spinner: spinner,
    })

}

</script>

<style scoped>
.required-input {
  --background: #EFEFEF;
}
</style>